import React from "react";
import { clsx } from "clsx";
import { assetUrl } from "@lib/assets";

const SIZES = { sm: "h-8 w-8 text-xs", md: "h-10 w-10 text-sm", lg: "h-16 w-16 text-xl", xl: "h-24 w-24 text-3xl" } as const;

/** A round profile picture, or the person's initial when there is none (or it fails to load). */
export const Avatar: React.FC<{
    name: string;
    src?: string | null;
    size?: keyof typeof SIZES;
    className?: string;
}> = ({ name, src, size = "md", className }) => {
    const [failed, setFailed] = React.useState(false);
    const url = assetUrl(src);
    React.useEffect(() => setFailed(false), [src]);
    return (
        <span
            className={clsx(
                "inline-flex flex-shrink-0 items-center justify-center overflow-hidden rounded-full bg-gradient-to-br from-primary/20 to-secondary/20 font-semibold text-primary dark:text-white",
                SIZES[size],
                className
            )}
            aria-hidden
        >
            {url && !failed ? (
                <img src={url} alt="" className="h-full w-full object-cover" onError={() => setFailed(true)} />
            ) : (
                (name.trim().charAt(0) || "?").toUpperCase()
            )}
        </span>
    );
};
